export default "__VITE_ASSET__CZaReHzu__"